import { observer } from 'mobx-react';

import { useFlag } from '../../../../services/launchDarkly';
import ClaimPromoGiftDialogV2 from '../ClaimPromoGiftDialogV2/ClaimPromoGiftDialog';

import ClaimPromoGiftDialog from './ClaimPromoGiftDialog';

export const ClaimPromoGiftDialogController = observer(() => {
  const isRedesignEnabled = useFlag('ui_redesign_promo_link', false);

  if (isRedesignEnabled) {
    return <ClaimPromoGiftDialogV2 />;
  }

  return <ClaimPromoGiftDialog />;
});
